import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'

export const isMaldivesCharterCarouselEnabled = (state: App.State) => (
  state.geo.currentRegionCode === 'AU' && config.BRAND === LUXURY_ESCAPES
)
